import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/styles/withStyles";

//Redux
import { connect } from "react-redux";
import { submitComment } from "../../redux/actions/dataActions";

// Mui stuff
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";

const styles = {};

const CommentForm = (props) => {
  const { classes, authenticated, submitComment, postId } = props;

  const [body, setBody] = useState("");
  const [errors, setErrors] = useState({});

  const newErrors = props.UI.errors;

  //Function to check if an objext is empty
  const isEmpty = (obj) => {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return JSON.stringify(obj) === JSON.stringify({});
  };

  useEffect(() => {
    if (newErrors) {
      setErrors(newErrors);
    }
    if (isEmpty(newErrors) && !props.UI.loading) {
      setBody("");
    }
  }, [newErrors, props.UI.loading]);

  const handleSubmit = (e) => {
    e.preventDefault();
    submitComment(postId, { body });
  };

  const commentFormMarkup = authenticated ? (
    <Grid item xs={12}>
      <form onSubmit={handleSubmit}>
        <TextField
          name="body"
          type="text"
          label="Join the Conversation..."
          error={errors.comment ? true : false}
          helperText={errors.comment}
          value={body}
          onChange={(e) => setBody(e.target.value)}
          fullWidth
        />
        <br /> <br />
        <Button type="submit" variant="contained" color="primary" fullWidth>
          Post Comment
        </Button>
      </form>
    </Grid>
  ) : null;

  return commentFormMarkup;
};

CommentForm.propTypes = {
  submitComment: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  postId: PropTypes.string.isRequired,
  authenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  UI: state.UI,
  authenticated: state.user.authenticated,
});

export default connect(mapStateToProps, { submitComment })(
  withStyles(styles)(CommentForm)
);
